import React from 'react';
import { Breadcrumb } from 'components';
import { useParams } from 'react-router-dom';
import BrowsePromoBrands from './BrowsePromoBrands';


export default function PromoLibrary() {
  const {selectedTab} = useParams();
  const selectedTabName = selectedTab?.split('-').join(' ');

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Automatic Promotions', path: '/my-promotions' },
            { name: `${selectedTabName}` }
          ]}
        />
      </div>
      <BrowsePromoBrands />
    </div>
  );
}
